import './style.scss';

if (
	( 'complete' === document.readyState ||
		'loading' !== document.readyState ) &&
	! document.documentElement.doScroll
) {
	sliderBlockGutenberg();
} else {
	document.addEventListener( 'DOMContentLoaded', sliderBlockGutenberg );
}

/**
 * Start Slider function
 */
function sliderBlockGutenberg() {

}
 